import { render, staticRenderFns } from "./TabEducation.vue?vue&type=template&id=29366848&scoped=true&"
import script from "./TabEducation.vue?vue&type=script&lang=js&"
export * from "./TabEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29366848",
  null
  
)

export default component.exports